export default __webpack_public_path__ + "static/media/jaipur5.7e7e2cfa.jpg";